module.exports = __webpack_public_path__ + "static/media/Twin Tower 2.7f5b7559.png";